import { ForwardRefExoticComponent } from 'react';

import { RadioProps } from '@mantine/core';

import { Radio as BaseRadio } from './Radio';
import { RadioGroup, RadioCard, RadioIndicator } from './RadioGroup';

type RadioComponent = ForwardRefExoticComponent<
  RadioProps & React.RefAttributes<HTMLInputElement>
> & {
  Group: typeof RadioGroup;
  Card: typeof RadioCard;
  Indicator: typeof RadioIndicator;
};

const Radio = BaseRadio as RadioComponent;

Radio.Group = RadioGroup;
Radio.Card = RadioCard;
Radio.Indicator = RadioIndicator;

export { Radio };
export type { RadioProps };
